import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { HttpService } from "../../service/HttpService";

const handleDownloadReorderExcel = async (setShowLoginPopup, ids = []) => {
  const httpService = new HttpService(setShowLoginPopup);

  const fetchReorderData = () => {
    return new Promise((resolve, reject) => {
      const idParam = ids.join(",");

      httpService
        .get(`inventory/reorder/byids?ids=${idParam}`)
        .then((response) => {
          if (response?.data) {
            resolve(response?.data);
          } else {
            reject(new Error("No data found"));
          }
        })
        .catch((error) => {
          console.error("Error fetching reorder data:", error);
          reject(error);
        });
    });
  };

  try {
    const reorderData = await fetchReorderData();
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Reorder Inventory");

    worksheet.addRow([
      "Item Name",
      "Stored Location",
      "Reorder Threshold",
      "Unit",
      "Reorder Amount",
      "On-Hand Quantity",
      "Department",
      "Employee",
      "Date",
    ]);
    worksheet.getRow(1).alignment = { horizontal: "center" };

    if (Array.isArray(reorderData) && reorderData.length > 0) {
      reorderData.forEach((item) => {
        worksheet.addRow([
          item?.item_name || "",
          item?.stored_location || "",
          parseFloat(item?.reorder_threshold) || "",
          item?.unit || "",
          parseFloat(item?.reorder_amount) || "",
          parseFloat(item?.on_hand_qty) || "",
          item?.department_name || "",
          item?.emp_name || "",
          item?.date ? moment(item.date).format("MM/DD/YYYY") : "",
        ]);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const formattedDate = moment().format("MM-DD-YYYY_hh-mm-ss_A");
    saveAs(new Blob([buffer]), `ReorderInventoryData_${formattedDate}.xlsx`);
  } catch (error) {
    console.error("Error downloading reorder Excel:", error);
  }
};

export { handleDownloadReorderExcel };
